import { useEffect, useState } from "react";

/**
 * Measures the max scrollWidth of elements matching `selector` under `rootRef`
 * and returns {maxRowWidth, containerProps} you can spread onto the wrapper.
 */
export default function UseMobileRowWidth({ enabled, rootRef, selector = ".ccv-row-inner" }) {
    const [maxRowWidth, setMaxRowWidth] = useState(null);

    useEffect(() => {
        if (!enabled) { setMaxRowWidth(null); return; }
        const root = rootRef.current;
        if (!root) return;

        const measure = () => {
            const nodes = root.querySelectorAll(selector);
            let max = 0;
            nodes.forEach(el => { max = Math.max(max, el.scrollWidth || 0); });
            setMaxRowWidth(max || null);
        };

        measure();
        const ro = new ResizeObserver(measure);
        ro.observe(root);
        window.addEventListener("resize", measure);
        return () => {
            ro.disconnect();
            window.removeEventListener("resize", measure);
        };
    }, [enabled, rootRef, selector]);

    const containerProps = {
        ref: rootRef,
        className: "ccv-mobile-list",
        style: maxRowWidth ? { "--ccv-row-width": `${maxRowWidth}px` } : undefined
    };

    return { maxRowWidth, containerProps };
}
